import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { AsyncTask, AsyncTaskTracker } from "../modules/async";
import { KryptonEventDetail } from './krypton-event-detail';
import { getContentHtml } from '../modules/global_function';

export abstract class KryptonElement extends LitElement {

    @property({ type: Object }) accessor debug = {
        events: {
            verboseDispatcher: false,
            verboseListener: false
        }
    };

    protected _asyncTaskTracker = new AsyncTaskTracker();

    getContentHtml(content: string): HTMLElement {
        return getContentHtml(content);
    }

    kryptonApp() {
        return window["kryptonApp"] && window["kryptonApp"]();
    }

    /* Polymer legacy support */
    fire(eventName: string, detail?: KryptonEventDetail) {
        try {
            this.dispatchEvent(new CustomEvent(eventName, { bubbles: true, composed: true, detail: detail }));
            this.debug.events.verboseDispatcher && console.debug("dispatched event:", eventName, detail);
        } catch (err) {
            this.debug.events.verboseDispatcher && console.debug("dispatched event error:", eventName, err);
        }
    }

    fireTo(eventName: string, eventTarget: HTMLElement, detail?: KryptonEventDetail) {
        try {
            eventTarget.dispatchEvent(new CustomEvent(eventName, { bubbles: true, composed: true, detail: detail }));
            this.debug.events.verboseDispatcher && console.debug("dispatched event:", eventName, detail);
        } catch (err) {
            this.debug.events.verboseDispatcher && console.debug("dispatched event error:", eventName, err);
        }
    }

    /* Polymer legacy support */
    async async(func: Function, delay?: any, name?: string): Promise<any> {
        const asyncTask = new AsyncTask(func, delay, name);
        this._asyncTaskTracker.track(asyncTask);
        return asyncTask.run();
    }

    /* Polymer legacy support */
    cancelAsync(name: string) {
        if (name === "all") this._asyncTaskTracker.cancelAll();
        else this._asyncTaskTracker.cancel(name);
    }

    getNestedSlotElements(initialSlot: HTMLSlotElement, elementType: any): HTMLElement[] {
        const elements: HTMLElement[] = [];
        const slots: HTMLSlotElement[] = [initialSlot];
        let slot;
        while (slot = slots.shift()) {
            slot.assignedNodes().forEach(node => {
                if (node instanceof HTMLSlotElement) slots.push(node);
                if (node instanceof elementType) elements.push(node);
            });
        }
        return elements;
    }

    // static mediaQueryMobile = window.matchMedia("only screen and (min-width: 320px) and (max-width: 767px)");
    // static mediaQueryTablet = window.matchMedia("only screen and (min-width: 768px) and (max-width: 991px)");
    // static mediaQueryDesktop = window.matchMedia("only screen and (min-width: 992px) and (max-width: 5120px)");

    static mediaQuerySmall = window.matchMedia("only screen and (max-width: 767px)");
    static mediaQueryMedium = window.matchMedia("only screen and (min-width: 768px) and (max-width: 991px)");
    static mediaQueryLarge = window.matchMedia("only screen and (min-width: 992px)");

    static formFactor(): FormFactor {
        if (KryptonElement.mediaQueryLarge.matches) {
            return "desktop";
        } else if (KryptonElement.mediaQueryMedium.matches) {
            return "tablet";
        } else if (KryptonElement.mediaQuerySmall.matches) {
            return "mobile"
        }
        return "desktop";
    }

}

export type FormFactor = "mobile" | "tablet" | "desktop";

declare global {
    interface HTMLElementTagNameMap {
        'krypton-element': KryptonElement;
    }
}
